<template>
  <div >
    <transition name="slide">
      <div v-if="showProfileMinePageBanner && showBanner" class="hero" role="banner">
        <div class="slides">
          <section class="hero slide">
            <div class="container is-flex">
              <div class="hero-body is-flex">
                <div class="text-container is-flex">
                  <div class="text">
                    <h1>Develop, Share & Explore STEM projects</h1>
                    <hr>
                    <p>Welcome to the easiest way to document, collaborate and present STEM ideas from the classroom, at home or for an event. Explore projects below, or check out our <span><a class="project-board" href="https://projectboard.world"> ProjectBoard communities and capabilities.</a></span> Want to learn how your community could use ProjectBoard?
                    </p>
                    <a @click.stop="connectWithUs">
                      <div class="button is-primary is-small signup-cta">CONNECT WITH US</div>
                    </a>
                  </div>
                </div>
                <div class="image-layer is-flex">
                  <div class="cloud-bulb is-flex">
                    <div class="cloud" ref="cloud" :class="{animated: animating.cloud, swing: animating.cloud}" @mouseenter="animate('cloud')">
                      <img src="/static/banner/cloud.svg" />
                    </div>
                    <div class="bulb" ref="bulb" :class="{animated: animating.bulb, swing: animating.bulb}" @mouseenter="animate('bulb')">
                      <img src="/static/banner/bulb.svg" />
                    </div>
                  </div>
                  <div class="rocket" ref="rocket"  :class="{animated: animating.rocket, bounce: animating.rocket}" @mouseenter="animate('rocket')">
                    <img src="/static/banner/rocket.svg" />
                  </div>
                </div>
              </div>
            </div>
            <div class="close cursor-pointer" @click="toggleBanner(false)"><span><i class="fal fa-chevron-up"></i></span></div>
          </section>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div v-if="!showBanner && showProfileMinePageBanner" class="closed">
        <div class="slides">
          <section class="closed slide">
            <div class="open cursor-pointer" @click="toggleBanner(true)"><span><i class="fal fa-chevron-down"></i></span></div>
          </section>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import auth from '@/mixins/auth'
import localStorage from 'store'
const bannerKey = 'welcome_banner'
export default {
  components: {
  },
  mixins: [auth],
  computed: {
    showProfileMinePageBanner: function () {
      return !this.$route.fullPath.includes('profile=mine')
    }
  },
  data: function () {
    return {
      showBanner: false,
      animating: { cloud: false, bulb: false, rocket: false },
      signupSource: 'LOGIN:{PATH}'
    }
  },
  created: function () {
    this.checkShowBanner()
  },
  mounted: function () {
    if (this.showBanner) {
      this.startAnimation()
    }
  },
  watch: {
    showBanner: function () {
      if (this.showBanner) {
        this.startAnimation()
      }
    }
  },
  methods: {
    connectWithUs: function () {
      window.open('https://projectboard.world/contact')
    },
    toggleBanner: function (show) {
      this.showBanner = show
      if (this.isLoggedIn) {
        const settings = { showBanner: show }
        this.$store.dispatch('updateUserSettings', { username: this.currentUser.userName, settings })
      } else {
        localStorage.set(bannerKey, this.showBanner)
      }
    },
    checkShowBanner: function () {
      if (this.isLoggedIn) {
        this.$store.dispatch('getUserSetting', 'showBanner').then((value) => {
          this.showBanner = !!value
        })
      } else {
        const show = localStorage.get(bannerKey)
        this.showBanner = show !== undefined ? show : true
      }
      return this.showBanner
    },
    showSignup: function (source) {
      if (!this.isLoggedIn) {
        this.passwordSet = false
        this.$store.dispatch('showLoginModal', { source })
      }
    },
    startAnimation: function () {
      this.$nextTick(() => {
        this.animate('cloud')
        this.animate('bulb')
      })
    },
    animate: function (key) {
      if (this.animating[key]) {
        return
      }
      this.animating[key] = () => this.stopAnimation(key)
      this.$refs[key].addEventListener('animationend', this.animating[key])
    },
    stopAnimation: function (key) {
      this.$refs[key].removeEventListener('animationend', this.animating[key])
      this.animating[key] = false
    },
    startNow: function () {
      if (this.$isEngCom) {
        this.$router.push({ name: 'create' })
      } else if (this.$isEngComApp) {
        this.$router.push({ name: 'mvpStart' })
      } else {
        this.$router.push({ name: 'createPost' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  hr {
    width: 100px;
    margin: 0.75rem auto;
    @include mobile {
      margin: 0.5rem auto;
    }
  }
  .hero {
    height: 350px;
    width: 100%;
    background-size: cover;
    // font-family: 'Montserrat', sans-serif;
    color: $white;
    justify-content: flex-start;
    position: relative;
    @include tablet-only {
      height: 400px;
    }
    @include fullhd {
      background-position: 0 100%;
      height: 450px;
    }
  }
  .slides {
    position: relative;
  }
  .slide {
    position: absolute;
    background-image: linear-gradient(to right, $secondary, #8409f9);
    background-position: center 20%;
    @include fullhd {
      background-position: 0 30%;
    }
  }
  .container {
    justify-content: center;
    align-items: center;
    height: 100%;
    @include touch {
      margin: 0;
    }
  }
  .hero-body {
    position: relative;
    justify-content: center;
    flex-direction: row;
    padding: 3rem 0;
    max-width: 650px;
    min-height: 300px;
    @include widescreen-only {
      max-width: 500px;
    }
    @include tablet-only {
      max-width: 550px;
    }
    @include mobile {
      max-width: 450px;
    }
    @include mini-mobile {
      max-width: 90%;
    }
  }
  .text-container {
    border-radius: 15px;
    background-color: rgba(255, 255, 255,0.1);
    justify-content: center;
    align-items: center;
    text-align: center;
    width: initial;
    padding: 1rem 0;
    z-index: 2;
    pointer-events: none;
    @include widescreen-only {
      padding: 2.25rem;
    }
  }
  .text {
    // font-family: 'Montserrat', sans-serif;
    justify-content: center;
    padding: 2rem;
    h1 {
      font-weight: 700;
      font-size: 1.7rem;
      text-align: center;
      @include widescreen-only {
        font-size: 1.3rem;
      }
      @include until-widescreen {
        font-size: 1.2rem
      }
    }
    p {
      display: inline-block;
      font-size: 1rem;
      line-height: 1.8;
      font-weight: 300;
      @include widescreen-only {
        font-size: 0.85rem;
      }
      @include mobile {
        font-size: 0.8rem;
      }
    }
    .read-more {
      pointer-events: initial;
      white-space: nowrap;
      a {
        color: $white;
        text-decoration: underline;
        &:hover {
          color: $secondary;
        }
      }
    }
    @include widescreen-only {
      padding: 0;
    }
    @include mobile {
      padding: 0;
    }
  }
  .project-board {
    color: $white;
    text-decoration: underline;
    pointer-events: initial;
  }
  .image-layer {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 4;
    pointer-events: none;
    img {
      @include mobile {
        width: 100%;
      }
    }
    .cloud-bulb {
      position: relative;
      left: -6rem;
      top: -2rem;
      pointer-events: initial;
      @include fullhd {
        top: -2.5rem;
      }
      @include mobile {
        left: -1.3rem;
        width: 90px;
      }
      @include mini-mobile {
        top: -4rem;
      }
    }
    .bulb {
      animation-duration: 1.25s;
      animation-delay: 0.1s;
    }
    .rocket {
      position: absolute;
      bottom: -1rem;
      right: -4rem;
      pointer-events: initial;
      @include mobile {
        right: -2rem;
        width: 100px;
      }
    }
  }
  .close, .open {
    font-size: 1.25rem;
    position: absolute;
    z-index: 3;
    right: 2rem;
    top: 0.25rem;
    @include mobile {
      font-size: 1rem;
      right: 0.75rem;
    }
  }
  .closed {
    position: relative;
    width: 100%;
    height: 2rem;
    color: $white;
  }
  // Same as in PR 2412, delete one or the other to resolve conflict.
  .signup-cta {
    border-radius: 15px;
    padding: 20px 40px;
    font-size: 1em;
    font-weight: 700;
    margin-top: 20px;
    pointer-events: initial;
    &:hover {
      background-color: $secondary;
    }
  }
  .signup-cta {
    border-radius: 15px;
    padding: 20px 40px;
    font-size: 1em;
    font-weight: 700;
    margin-top: 20px;
    pointer-events: initial;
    &:hover {
      background-color: $secondary;
    }
  }
  .fade-enter-active, .fade-leave-active {
    &.closed, .closed {
      transition: height 0.5s ease;
    }
    .open {
      transition: opacity 0.2s ease;
    }
  }
  .fade-enter, .fade-leave-to {
    &.closed, .closed {
      height: 0;
    }
    .open {
      opacity: 0;
    }
  }
  .slide-enter-active, .slide-leave-active {
    &.hero, .hero {
      transition: height 0.5s ease;
    }
    .container, .close {
      transition: opacity 0.3s ease;
    }
  }
  .slide-enter, .slide-leave-to {
    &.hero, .hero {
      height: 0;
    }
    .container, .close {
      opacity: 0;
    }
  }
</style>
